export default __webpack_public_path__ + "static/media/img-slider-ommerchant-4.e509b6c6.png";